import React, { lazy } from "react";

const Cells = lazy(() => import("./cells"));
const Products = lazy(() => import("./products"));
const Facilities = lazy(() => import("./facilities"));
const Equipment = lazy(() => import("./equipment"));
const AddEquipmentToLine = lazy(() => import("./add-equipment-to-line"));
const Users = lazy(() => import("./users"));
const CellLayout = lazy(() => import("./cell-layout"));

const AdminRoute = () => {
  return [
    {
      key: "cells",
      path: "/general_admin/cells",
      component: <Cells />,
    },
    {
      key: "products",
      path: "/general_admin/products",
      component: <Products />,
    },
    {
      key: "facilities",
      path: "/general_admin/facilities",
      component: <Facilities />,
    },
    {
      key: "equipment",
      path: "/general_admin/equipment",
      component: <Equipment />,
    },
    {
      key: "equipment-add",
      path: "/general_admin/equipment/add",
      component: <AddEquipmentToLine />,
    },
    {
      key: "users",
      path: "/general_admin/users",
      component: <Users />,
    },
    {
      key: "cell-layout",
      path: "/general_admin/cell-layout",
      component: <CellLayout />,
    },
  ];
};

export default AdminRoute;
